import { z } from 'zod';
import { ActionSchema } from '../actions';

export const ConsentBlockSchema = z.object({
  id: z.string().min(1),
  type: z.literal('consent'),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(ActionSchema).optional() }).optional(),
  props: z.object({ text: z.string().max(2000), checkbox_label: z.string().min(1) })
});